/* Generated file */

export enum EtatAvancementProjet {
	AnalyseTechnique = "AnalyseTechnique",
	Chantier = "Chantier",
	Livre = "Livre",
	NonPrecise = "NonPrecise",
	Opportunite = "Opportunite",
}
